import React, { Component } from 'react';
import {static_links} from "../../../constants/static_links";

const PackBenefits = ({pack,showPopup}) => {
    return (
        <div>
            <p className="pull-right cursor-pointer" onClick={()=>{
                showPopup()
            }}><img src={`${process.env.PUBLIC_URL}/assets/images/outlined-cross.svg`} width="15"/></p>
            <p className="fs-20 color-dark-grey">
            Charges post consumption of pack benefits
        </p>

        <div className="pack-benifits">
            <table className="width-full border-collapse" >
                { pack.standardCharges.map((benefit, index) =>{

                        return (
                            <tr className="border-bottom-bar">
                                <td className="border-bottom-bar pt-10 pb-10"><p className="fs-12 color-6-grey">{benefit.label}</p></td>
                                <td className="border-bottom-bar pt-10 pb-10 text-right"><p className="fs-12 color-6-grey">{benefit.quota}</p></td>
                            </tr>
                        )
                })}
            </table>
        </div>
        <div><p className="fs-14 fs-regular"><a target='_blank' href={static_links.ir_pack_tnc}>Terms &amp; Conditions </a>and <a  target='_blank' href={static_links.ir_pack_standard_charges}>Standard roaming charges</a> applicable</p></div>
        </div>

    );
}

export default PackBenefits;


// WEBPACK FOOTER //
// ./src/components/message-components/ir-packs-components/packbenefits.js